// extracted by mini-css-extract-plugin
export default {"exit":"CloseWindowButton_exit__6xcf7","mobile":"CloseWindowButton_mobile__3MACc"};